import { lazy } from "react";

const AppIcons = lazy(() => import("../../components/Base/AppIcons"));
const ViewsReviewActualizarCorregir = lazy(
  () => import("./views/ViewsReviewActualizarCorregir")
);
const ViewReviewValidar = lazy(() => import("./views/ViewReviewValidar"));
const ViewListarValidar = lazy(() => import("./views/ViewListarValidar"));

export const rutasLink = {
  actualizar_corregir: "/review-commerce-actualizar-corregir",
};

const rutasActualizacionComercio = [
  {
    link: rutasLink.actualizar_corregir,
    label: (
      <AppIcons
        Logo={"ACTUALIZACION_DATOS"}
        name="Actualización de Datos Comercios"
      />
    ),
    component: ViewsReviewActualizarCorregir,
    permission: [7],
    subRoutes: [],
    show: false,
  },
  {
    link: "/review-commerce-validar",
    label: (
      <AppIcons
        Logo={"ACTUALIZACION_DATOS"}
        name="Validación Actualización de Datos"
      />
    ),
    component: ViewListarValidar,
    permission: [9],
    subRoutes: [
      {
        link: "/review-commerce-validar/comercio",
        label: (
          <AppIcons
            Logo={"ACTUALIZACION_DATOS"}
            name="Validación Actualización de Datos"
          />
        ),
        component: ViewReviewValidar,
        permission: [9],
      },
    ],
  },
];
export default rutasActualizacionComercio;
